// extracted by mini-css-extract-plugin
module.exports = {"perks":"Perks_perks__gaDAT","perk":"Perks_perk__r5wdA"};